exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper-main-chips {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 4px; }\n  .wrapper-main-chips .wrapper-chips {\n    padding-bottom: 7px;\n    width: 90%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-align: center;\n        align-items: center; }\n    .wrapper-main-chips .wrapper-chips .chip-button {\n      border: 1px solid #ccc;\n      padding: 3px 12px;\n      background-color: #d4d4d4;\n      border-radius: 10px;\n      cursor: pointer;\n      box-sizing: border-box;\n      box-shadow: 0 2px 3px 0 #aeaeae;\n      margin-right: 5px;\n      font-size: 11px;\n      text-transform: uppercase;\n      margin-top: 5px; }\n    .wrapper-main-chips .wrapper-chips .more-notes-template {\n      text-decoration: none;\n      cursor: pointer;\n      margin-left: 5px;\n      margin-top: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/note-template-chips/note-template-chips.component.scss
// module id = 2193
// module chunks = 66